export default "__VITE_ASSET__DrZLOaM4__"